import { Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, DrawerProps, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = Pick<DrawerProps, 'size'> & {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export const EmailDrawer = ({ onClose, isOpen, size = '7xl', children }: Props) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={size}>
      <DrawerOverlay />
      <DrawerContent>
        <Flex direction="row" w="7xl" h="full">
          {children}
        </Flex>
        <DrawerCloseButton onClick={onClose} />
      </DrawerContent>
    </Drawer>
  );
};
